import clsx from 'clsx';
import React from 'react';
import WorkbookIcon from '@/components/misc/WorkbookIcon';
import { CloseButton } from '@/components/ModalHoc';
import DataSourceSelect from '../../DataSourceSelect';
import { unsyncSourceOptions } from '../../hooks/useDataSourceSelect';
import GoogleDriveSync from '../../GoogleDriveSync';
import ErrorsButton from '../ErrorsButton';
import modalHeaderStyles from '@/components/Editor/modals/Header/styles.module.scss';
import styles from './styles.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const DataEditorHeader = _ref => {
  let {
    className,
    workbookName = 'Data',
    originFileType = '',
    isLoading = false,
    isSynchronizing = false,
    isSyncLoading = false,
    showSubHeader = false,
    showDriveSyncControl = false,
    errors = [],
    dataSourceOptions = [],
    onAddNewData = () => undefined,
    onErrorsListActivate = () => undefined,
    onSyncStateChange = () => undefined
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("header", {
      className: clsx(modalHeaderStyles.container, styles.container, className || ''),
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.headerLeft,
        children: [/*#__PURE__*/_jsx("h3", {
          className: clsx(styles.heading, modalHeaderStyles.heading, modalHeaderStyles['heading--hasIcon']),
          title: workbookName,
          children: isLoading ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(WorkbookIcon, {
              className: styles.headingIcon,
              originFileType: originFileType
            }), /*#__PURE__*/_jsx("span", {
              className: styles.heading__text,
              children: workbookName
            })]
          })
        }), showDriveSyncControl && !showSubHeader && /*#__PURE__*/_jsx("div", {
          className: styles.syncSwitch,
          children: /*#__PURE__*/_jsx(GoogleDriveSync, {
            checked: isSynchronizing,
            isLoading: isSyncLoading,
            handleSyncStateChange: onSyncStateChange
          })
        })]
      }), !showSubHeader && /*#__PURE__*/_jsxs("div", {
        className: styles.headerActions,
        children: [errors !== null && errors !== void 0 && errors.length ? /*#__PURE__*/_jsx(ErrorsButton, {
          counter: errors.length,
          onClick: onErrorsListActivate
        }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(DataSourceSelect, {
          className: clsx(styles.headerUpload, styles['headerUpload--large']),
          variant: "large",
          disabled: isLoading || isSynchronizing,
          options: isSynchronizing ? unsyncSourceOptions : dataSourceOptions,
          onSelect: onAddNewData
        })]
      }), /*#__PURE__*/_jsx(CloseButton, {
        className: clsx(modalHeaderStyles.close, styles.modalCloseBtn)
      })]
    }), showSubHeader && /*#__PURE__*/_jsxs("div", {
      className: styles.subHeader,
      children: [showDriveSyncControl ? /*#__PURE__*/_jsx(GoogleDriveSync, {
        checked: isSynchronizing,
        isLoading: isSyncLoading,
        handleSyncStateChange: onSyncStateChange
      }) :
      /*#__PURE__*/
      // Create placeholder for upload button
      _jsx("div", {}), /*#__PURE__*/_jsx(DataSourceSelect, {
        className: clsx(styles.headerUpload, styles['headerUpload--small']),
        disabled: isLoading || isSynchronizing,
        options: isSynchronizing ? unsyncSourceOptions : dataSourceOptions,
        onSelect: onAddNewData
      })]
    })]
  });
};

export default DataEditorHeader;